import { useEffect } from 'react';

import BannerInfo from 'components/BannerInfo';
import Card from 'components/Card';
import CompanyAccepted from 'components/CompanyAccepted';
import CompanyError from 'components/CompanyError';
import CompanyRejected from 'components/CompanyRejected';
import CompanyValidation from 'components/CompanyValidation';
import { STEP_ACCEPTED, STEP_ERROR_LOADING, STEP_REJECTED, STEP_VALIDATION } from 'context/CompanyValidationProvider/constants';
import { useCompanyValidationStore } from 'context/CompanyValidationProvider/hooks';

const CompanyCheck = () => {
  const [companyValidationState] = useCompanyValidationStore();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [companyValidationState]);

  return (
    <>
      <Card>
        {companyValidationState.step === STEP_VALIDATION && <CompanyValidation />}
        {companyValidationState.step === STEP_ACCEPTED && <CompanyAccepted />}
        {companyValidationState.step === STEP_REJECTED && <CompanyRejected />}
        {companyValidationState.step === STEP_ERROR_LOADING && <CompanyError />}
      </Card>
      <BannerInfo />
    </>
  );
};

export default CompanyCheck;
